export default {
  // confirm info/warning
  confirm_Info_Warning: 0,

  // confirm yes_no
  confirm_Yes_No: 1,

  // confirm yes_no_cancel
  confirm_Yes_No_Cancel: 2,

  // confirm delete
  confirm_Delete: 3,

  // confirm Đóng
  confirm_Close: 4
};
